<div class="home-container page-container">
    <p class="text">Quick Binding Guide<mat-icon fontIcon="info_outlined"
            (click)="openInfo()"></mat-icon></p>
    <div class="center-container">
        <div class="steps">
            <div class="step"><img src="/assets/images/icons/qrcode.svg" alt="">
                <div>Point your phone at the <b>QR code</b> on the keynexis® control panel.</div>
            </div>
            <div class="step"><img src="/assets/images/icons/door.svg" alt="">
                <div>Take a quick photo of the storage unit <b>number</b> on the <b>door</b>.</div>
            </div>
            <div class="step"><img src="/assets/images/icons/success.svg" alt="">
                <div>Wait for binding, then confirm everything looks right.
                </div>
            </div>
        </div>
    </div>
    <div class="actions">
        <button mat-flat-button (click)="startApp()"> Start binding</button>
    </div>
</div>